import React from 'react'
import styled from 'styled-components'
import { Location } from 'history'

// Constants
import { RouteProps, routes } from 'constants/routes'

// Components
import { useToast } from 'containers/ToastManager'
import { LinkButton } from 'components/Button'
import ForgotPasswordForm from 'components/ForgotPasswordForm'
import { StyledLinkButton } from './ForgotPasswordView.styles'
import IndexLayout, { Title, Subtitle } from 'components/IndexLayout'

// Styles
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

// Types
interface LocationState {
  from: string
}

interface ForgotPasswordViewProps extends RouteProps<'FORGOT_PASSWORD'> {
  location: Location<LocationState>
}

const ForgotPasswordView: React.FC<ForgotPasswordViewProps> = props => {
  const {
    location: { state },
  } = props
  const { showToast } = useToast()

  return (
    <IndexLayout headerLink="sign-up" variant="teal">
      <ForgotPasswordForm
        onCompleted={data => {
          const errors = data.userRequestPasswordReset?.errors || []

          if (errors.length > 0) {
            const apiErrors = errors.map(error => error?.message)
            showToast(apiErrors.join('; '), 'negative')
          }
        }}
        onError={error => {
          showToast(error.message, 'negative')
        }}>
        {formikProps =>
          formikProps.successful ? (
            <Wrapper>
              <Title>Forgot Your Password?</Title>
              <Subtitle>
                If there is an account associated with this email address you
                will receive a password reset email.
              </Subtitle>
              <LinkButton
                to={{ pathname: routes.SIGN_IN.create({}), state }}
                variant="primary-untinted">
                Go back to Sign in
              </LinkButton>
            </Wrapper>
          ) : (
            <>
              <Title>Forgot Your Password?</Title>
              <Subtitle>
                Enter the email address you use to sign in to Sketch.
              </Subtitle>
              <ForgotPasswordForm.Fields {...formikProps} />
              <ForgotPasswordForm.Submit {...formikProps} />
              <StyledLinkButton
                variant="secondary"
                isUnderlined
                to={{ pathname: routes.SIGN_IN.create({}), state }}>
                Sign in
              </StyledLinkButton>
            </>
          )
        }
      </ForgotPasswordForm>
    </IndexLayout>
  )
}

export default ForgotPasswordView
